import React from 'react';

const Modal = ({ isOpen, onClose, services }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-6 w-11/12 sm:w-8/12 max-w-4xl h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-purple-500">Our Services</h2>
          <button
            className="text-gray-500 hover:text-gray-700"
            onClick={onClose}
          >
            &times;
          </button>
        </div>
        <div className="space-y-4">
          {services.map((service, index) => (
            <div
              key={index}
              className="border rounded-md p-4 hover:shadow-lg transition-shadow duration-300"
            >
              <h3 className="font-bold text-purple-500">{service.name}</h3>
              <p className="text-sm text-gray-700">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Modal;
